import { Component, OnInit } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { PipesModule } from 'app/pipes/pipes.module';
import { AppService } from 'app/services/app/app.service';

@Component({
  selector: 'app-terms-conditions',
  templateUrl: './terms-conditions.component.html',
  styleUrls: ['./terms-conditions.component.scss'],
  standalone: true,
  imports: [PipesModule, MatCardModule]
})
export class TermsConditionsComponent implements OnInit {

  constructor(private appService: AppService) { }

  ngOnInit(): void {
    this.appService.setMeta(
      'Terminos y condiciones - ' + this.appService.getTraduccion('meta.title'), 
      this.appService.getTraduccion('meta.description'), 
      this.appService.getTraduccion('meta.keywords')
    );
  }

}
